<template>
  <AppAdsense
    ad-class="google-ad--footer"
    ad-style="display:block"
    ad-client="ca-pub-9118328092882671"
    ad-slot="2993099815"
  />
</template>
